module.exports = __webpack_public_path__ + "static/img/1_0033.f1c550e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0033.jpg
// module id = qPCc
// module chunks = 0